import MenuDivider from '../MenuDivider/MenuDivider'
import MenuEntry from '../MenuEntry/MenuEntry'
import type { MenuSectionView } from '../types'

interface MenuSectionProps {
  section: MenuSectionView
  expanded: boolean
  fill: boolean
}

// A fragment, not a wrapper: every menu slot must stay a direct child of the menu card, which sizes and measures them.
const MenuSection = ({ section, expanded, fill }: MenuSectionProps) => (
  <>
    <MenuDivider hidden={!section.withDivider} />
    {section.entries.map(entry => (
      <MenuEntry key={entry.id} entry={entry} expanded={expanded} fill={fill} />
    ))}
  </>
)

export default MenuSection
